import { Entities, Periods, MetricDataPoint } from 'cio/utils/metrics/common';
import moment from 'moment-timezone';
import { computed } from '@ember/object';

export class SegmentMembershipMetric {
  entityId: number | string;
  entityType: Entities = Entities.SEGMENT;
  fetchedAt: number; // unix timestamp when this metric was received from the API
  resolution: Periods;

  environmentId?: number;

  start: number;
  end: number;

  range: { start?: moment.Moment; end?: moment.Moment } | null;

  total: MetricDataPoint[] = [];
  entered: MetricDataPoint[] = [];
  left: MetricDataPoint[] = [];

  @computed('entered.[]', 'left.[]')
  get netChange() {
    return this.entered.map((p, i) => ({
      x: p.x,
      y: (p.y ?? 0) - (this.left[i].y ?? 0),
    }));
  }

  constructor(obj: any) {
    this.entityId = obj.entityId;
    this.range = obj.range;

    this.resolution = obj.result?.resolution;

    this.start = obj.result?.start;
    this.end = obj.result?.end;

    this.total = obj.membershipData.total;
    this.entered = obj.membershipData.entered;
    this.left = obj.membershipData.left;

    this.fetchedAt = Math.floor(Date.now() / 1000);

    if (obj.meta?.environmentId) {
      this.environmentId = obj.meta.environmentId;
    }
  }
}
